import React from 'react';
import stylesDatiSideBar from './DatiSideBar.module.scss';
import {useSelector} from 'react-redux';

const SideBar = () => {

    const linkTrasparenza = useSelector(state => state.dataReducer.documentiPdf.linkTrasparenza);
    const linkSicurezza = useSelector(state => state.dataReducer.documentiPdf.linkSicurezza);
    const linkCookies = useSelector(state => state.dataReducer.documentiPdf.linkCookies);
    const linkPrivacy = useSelector(state => state.dataReducer.documentiPdf.linkPrivacy);

    const fullYear = () => {
        return new Date().getFullYear();
    }

    return(
        <div className={stylesDatiSideBar.DatiSideBar}>
            <a className={stylesDatiSideBar.link} href={linkTrasparenza} target="_blank" rel="noopener noreferrer">Trasparenza</a>
            <div className={stylesDatiSideBar.Clear}></div>
            <a className={stylesDatiSideBar.link} href={linkSicurezza} target="_blank" rel="noopener noreferrer">Sicurezza</a>
            <div className={stylesDatiSideBar.Clear}></div>
            <a className={stylesDatiSideBar.link} href={linkCookies} target="_blank" rel="noopener noreferrer">Cookies</a>
            <div className={stylesDatiSideBar.Clear}></div>
            <a className={stylesDatiSideBar.link} href={linkPrivacy} target="_blank" rel="noopener noreferrer">Privacy</a>
            <div className={stylesDatiSideBar.Clear}></div>
            <p className={stylesDatiSideBar.credits}>© {fullYear()} Prestipay S.p.A.</p>
            <p className={stylesDatiSideBar.credits}>Tutti i diritti riservati</p>
        </div>
    )
}

export default SideBar;